import { Injectable } from '@angular/core';
import {AuthService} from "./auth.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, map, switchMap, tap} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ListService {

  private apiUrl = environment.api.url;

  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getCountries(): Observable<{ countries: any[] }> {
    const url = `${this.apiUrl}/countries`;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    return this.http.get<any>(url, httpOptions).pipe(
      map(response => {
        if (!response || !response.data) {
          // Log a specific error if countries data is missing
          console.error('Failed to load countries: No data received', response);
          throw new Error('Failed to load countries: No data received');
        }
        return { countries: response.data };
      }),
      catchError(error => {
        console.error('Error during fetching countries:', error);  // Log the error encountered during the API call
        return throwError(() => new Error(`Failed to load countries: ${error.message}`));
      })
    );
  }
}
